import toast from "react-hot-toast";
export { default as NotificationsToaster } from "./NotificationsToaster";

export const addToast = (message, type, autoDismiss = true, correlationId = null) => {
  toast({ message, type, correlationId }, { duration: type === "error" || !autoDismiss ? Infinity : 4000 });
};
